import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Filter from '../../components/filter';
import FooterProfile from '../../components/footer_profile';
import RFQTable from '../../components/quantila/rfqs_table';
import Navbar from '../../components/navbar';
import isLoggedIn from '../../utils/isLoggedIn';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const RFQS = () => {
  //set initial states, comics, characters and query filters
  const url = `${process.env.REACT_APP_API}`;
  const token = sessionStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [products, setProducts] = useState([]);
  const filters = useSelector((state) => state.filters);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Get all products and equipments to display -------------\\
  useEffect(() => {
    const getProducts = async () => {
      const { searchStr, displayCount, isValidated, page } = filters;
      // Get listings on page load..
      const response = await axios.get(
        `${url}/admin/quantila/rfqs?searchStr=${searchStr}&displayCount=${displayCount}&isValidated=${isValidated}&page=${page}`,
        { headers: { authorization: `Bearer ${token}` } },
      );
      const [count, products] = convertEntitiesDeep(response.data);
      setProducts(products);
      setCount(count);

      setLoading(false);
    };

    //check if user is logged in
    isLoggedIn(navigate, dispatch, '/quantila/rfqs');
    const timeoutId = setTimeout(() => {
      getProducts();
    }, 300);

    return () => {
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [filters]);

  // Component return .. .. COMIC or CHARACTER;;
  return isLoading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS: product listings</title>
        <meta name='page' content='incoming product listings' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    //All products .. map and render products table
    <>
      <Helmet>
        <title>Badgers SAS: RFQs</title>
        <meta name='page' content='quantila rfqs' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className=''>
        <Filter count={count} displayMob={true} />
        <div className='container'>
          <div>
            <Link className='page-links' to='/'>
              <FontAwesomeIcon icon='home' />{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <span className='link-span'>SENT RFQS</span>
          </div>

          <div className='container'>
            <div className='col-12 d-flex justify-content-center my-4'>
              <h4 className='h4'>
                SENT RFQs <FontAwesomeIcon icon='fax' />
              </h4>
            </div>
            <RFQTable products={products} />
          </div>
        </div>

        <FooterProfile />
      </div>
    </>
  );
};

export default RFQS;
